import { asRecord, numberValue, stringValue } from './types';

function timestamp(value: unknown) {
  if (typeof value !== 'string') return 'Unbekannt';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 'Unbekannt' : new Intl.DateTimeFormat('de-DE', { dateStyle: 'medium' }).format(date);
}
function days(value: number | null) { return value === null ? 'Unbekannt' : `${value} Tage`; }

export function ListingObservationPanel({ value }: { value: unknown }) {
  const data = asRecord(value);
  if (data.schemaVersion !== 'listing-observation-period/v2') return <section className="data-section"><h2>Beobachtungszeitraum</h2><p>Belastbare Sichtungsdaten sind noch nicht verfügbar. Der gespeicherte Status bestätigt keine heutige Verfügbarkeit.</p></section>;
  return <section className="data-section"><h2>Beobachtungszeitraum</h2><dl>
    <dt>Erstmals beobachtet</dt><dd>{timestamp(data.firstObservedAt)}</dd>
    <dt>Zuletzt beobachtet</dt><dd>{timestamp(data.lastObservedPresentAt)}</dd>
    <dt>Zeitspanne zwischen Sichtungen</dt><dd>{days(numberValue(data, 'observedSpanDays'))}</dd>
    <dt>Alter seit Erfassung</dt><dd>{days(numberValue(data, 'daysSinceFirstSeen'))}</dd>
    <dt>Letzte Sichtung liegt zurück</dt><dd>{days(numberValue(data, 'daysSinceLastObservedPresent'))}</dd>
    <dt>Gespeicherter Status</dt><dd>{stringValue(data, 'recordedStatus') ?? 'Unbekannt'}</dd>
    <dt>Heutige Verfügbarkeit</dt><dd>Ungeprüft</dd>
  </dl><p>Die Zeitspanne belegt keine durchgehende Verfügbarkeit und keinen Verkauf. Veröffentlichung und tatsächliche Online-Dauer sind unbekannt.</p>{Array.isArray(data.warnings) && data.warnings.some(warning => ['invalid_timestamp', 'future_timestamp', 'backdated_last_seen'].includes(String(warning))) && <p>Einige Zeitangaben sind ungültig, liegen in der Zukunft oder wurden zurückdatiert. Sie benötigen Prüfung.</p>}</section>;
}
